import { Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { addProperty, getProperties } from '../Services/PortfolioService';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Breadcrumbs from '../CommonElements/Breadcrumbs';
import Table from '../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { MoreVertical, Eye, Pencil } from 'lucide-react';
import { Btn } from '../AbstractElements';
import Modal from '../CustomComponent/Modals/Modal';
import { useNavigate, useParams } from 'react-router-dom';

export default function Client() {
    const navigate = useNavigate();
    const { clientId } = useParams()
    const [client, setClient] = useState<any>(null);
    const [properties, setProperties] = useState<any>([]);
    const [propertyModalOpen, setPropertyModalOpen] = useState(false);
    const togglePropertyModal = () => setPropertyModalOpen(!propertyModalOpen);

    const [editProperty, setEditProperty] = useState<any>(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const toggleEditModal = () => setEditModalOpen(!editModalOpen);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [contactName, setContactName] = useState('');

    const handleAddProperty = async () => {
        try {
            const data = {
                name,
                address,
                email_address: email,
                contact_name: contactName
            }
            const propertiesData = await addProperty(clientId!, data);
            fetchProperties()
        } catch (error: any) {
            toast.error(error.message || "Failed to add Property");
        }
        // Here you can process form inputs later
        togglePropertyModal();
    };

    const handleEditProperty = async () => {
        if (!editProperty) return;
        try {
            const updated = {
                name,
                address,
                email_address: email,
                contact_name: contactName
            };
            await editProperty(clientId!, updated, editProperty.id); // Assuming `addProperty` handles updates when an ID is passed
            toast.success("Property updated!");
            fetchProperties();
            toggleEditModal();
        } catch (error: any) {
            toast.error(error.message || "Failed to update property");
        }
    };

    const ActionDropdown = ({ row }: { row: any }) => {
        const [dropdownOpen, setDropdownOpen] = useState(false);
        const toggle = () => setDropdownOpen(prevState => !prevState);

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                <DropdownToggle color="transparent" className="p-0 border-0 shadow-none">
                    <MoreVertical size={18} />
                </DropdownToggle>
                <DropdownMenu end>
                    <DropdownItem onClick={() => console.log('View', row)}>
                        <Eye size={16} color="green" className="me-2" />
                        View
                    </DropdownItem>
                    <DropdownItem onClick={() => {
                        setEditProperty(row);
                        setName(row.name);
                        setAddress(row.address);
                        setContactName(row.contact_name);
                        setEmail(row.email_address);
                        toggleEditModal();
                    }}>
                        <Pencil size={16} color="orange" className="me-2" />
                        Edit
                    </DropdownItem>
                    {/* <DropdownItem onClick={() => console.log('Delete', row)}>
                        <Trash2 size={16} color="red" className="me-2" />
                        Delete
                    </DropdownItem> */}
                    {/* {
                        row.status == 'no access' ?
                            <DropdownItem onClick={() => console.log('Delete', row)}>
                                <Unlock size={16} color="green" className="me-2" />
                                Grant Access
                            </DropdownItem> :
                            <DropdownItem onClick={() => console.log('Delete', row)}>
                                <Lock size={16} color="red" className="me-2" />
                                Revoke Access
                            </DropdownItem>
                    } */}
                </DropdownMenu>
            </Dropdown>
        );
    };

    const tableColumns: TableColumn<any>[] = [
        {
            name: "S/N",
            cell: (_row, index) => index + 1,
            sortable: false,
            width: '70px',
        },
        {
            name: "Property Name",
            cell: (row: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => navigate(`${process.env.PUBLIC_URL}/client/property/${row.property_id}`)}>
                        <span className="text-primary" style={{ whiteSpace: 'nowrap' }}>{row.name || ''}</span>
                    </div>
                );
            },
            sortable: true,
            center: false,
        },
        {
            name: "Address",
            selector: (row) => row.address,
            sortable: false,
            center: false,
        },
        {
            name: "Contact Name",
            selector: (row) => row.contact_name,
            sortable: false,
            center: false
        },
        {
            name: "Email Address",
            cell: (row) => row.email_address,
            sortable: false,
            center: false,
        },
        {
            name: 'Actions',
            cell: (row) => <ActionDropdown row={row} />,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
        },
    ];

    useEffect(() => {
        if (clientId) {
            fetchProperties();
            localStorage.setItem('selectedClient', clientId);
        }
    }, [clientId]);

    const fetchProperties = async () => {
        try {
            const response = await getProperties(clientId!);
            setProperties(response.properties);
            setClient(response.client);
        } catch (error: any) {
            toast.error(error?.message || "Failed to fetch Properties");
        }
    };

    return (
        <>
            <Breadcrumbs pageTitle='Portfolio' />
            <Container className='default-dashboard' fluid>
                {client && (
                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="p-4 border border-primary rounded shadow-sm">
                                <Row className="gy-3">
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Company Name</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Email Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.email_address}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Country</small>
                                            <div className="text-primary fw-bold">{client.country?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">No. of Properties</small>
                                            <div className="text-primary fw-bold">{properties.length}</div>
                                        </div>
                                    </Col>
                                    <Col lg="8" md="12">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.address}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col sm="12" className="d-flex justify-content-end">
                        <Btn color='primary' className="mb-3" onClick={togglePropertyModal}>Add Property</Btn>
                    </Col>

                    <Table title='Properties' tableColumns={tableColumns} data={properties} />
                </Row>

                <Modal isOpen={propertyModalOpen} toggle={togglePropertyModal} action={handleAddProperty} title="Add New Property" button='Add' size='xl'>
                    <Form>
                        <Row style={{ marginTop: '5px' }}>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for={`property-name`}>Property Name</Label>
                                    <Input
                                        id={`property-name`}
                                        name="property-name"
                                        type="text"
                                        placeholder="Enter property name"
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for={`property-address`}>Property Address</Label>
                                    <Input
                                        id={`property-address`}
                                        name="property-address"
                                        type="text"
                                        placeholder="e.g. 5"
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for={`contact-name`}>Contact Name</Label>
                                    <Input
                                        id={`contact-name`}
                                        name="contact-name"
                                        type="text"
                                        placeholder="Enter contact name"
                                        onChange={(e) => setContactName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for={`contact-email`}>Contact Email</Label>
                                    <Input
                                        id={`contact-email`}
                                        name="contact-email"
                                        type="email"
                                        placeholder="Enter contact email"
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Modal>

                <Modal isOpen={editModalOpen} toggle={toggleEditModal} action={handleEditProperty} title="Edit Property" button="Update" size="xl">
                    <Form>
                        <Row className="mt-3">
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="edit-property-name">Property Name</Label>
                                    <Input
                                        id="edit-property-name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="edit-property-address">Property Address</Label>
                                    <Input
                                        id="edit-property-address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="edit-contact-name">Contact Name</Label>
                                    <Input
                                        id="edit-contact-name"
                                        value={contactName}
                                        onChange={(e) => setContactName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='3'>
                                <FormGroup>
                                    <Label for="edit-contact-email">Contact Email</Label>
                                    <Input
                                        id="edit-contact-email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </Container>
        </>
    );
}